import { endOfDay, startOfMonth } from 'date-fns';

import type { DateRange } from 'infrastructure/types';

export const currentMonthRange: DateRange = [
  startOfMonth(new Date()),
  endOfDay(new Date()),
];
